<template>
  <div class="terms">
    <el-card class="box-card terms-card">
      <div class="content">
        欢迎您加入本站点参加交流和讨论，本站点为商业、技术交流论坛，不涉及任何政治问题，<br />
        为维护网上公共秩序和社会稳定，请您自觉遵守以下条款：<br />
        　一、不得利用本站制作、复制和传播下列信息：<br />
        　　　1、煽动抗拒、破坏宪法和法律、行政法规实施的；<br />
        　　　2、煽动颠覆国家政权，推翻社会主义制度的；<br />
        　　　3、煽动分裂国家、破坏国家统一的；<br />
        　　　4、煽动民族仇恨、民族歧视，破坏民族团结的；<br />
        　　　5、捏造或者歪曲事实，散布谣言，扰乱社会秩序的；<br />
        　　　6、宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀；<br />
        　　　7、公然侮辱他人或者捏造事实诽谤他人的；<br />
        　　　8、损害国家机关信誉的；<br />
        　　　9、其他违反宪法和法律行政法规的；<br />
        　二、互相尊重，对自己的言论和行为负责。<br />
        　三、版主和管理员有权修改或删除违反本协议的帖子.<br />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "TermsView",
  data() {
    return {
      forum: null,
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.$store.dispatch("app/setBreadcrumb", [
        {
          key: 1,
          link: "/terms.html",
          value: "用户须知",
        },
      ]);
    },
  },
};
</script>
<style lang="less">
.terms-card {
  .content {
    width: 650px;
    margin: 0 auto;
    text-align: left;
  }
}
</style>
